<template>
  <b-overlay
    :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <b-button
          v-if="$route.params.id !== undefined"
          variant="success"
          :to="{ name: 'devices-add' }"
        >
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }}
          </span>
        </b-button>
        <span v-else />
      </template>
    </app-breadcrumb>
    <b-row>
      <b-col md="12">
        <b-card aria-hidden="true">
          <!-- Alert: No item found -->
          <b-alert
            variant="danger"
            :show="errorMessage !== ''"
          >
            <h4 class="alert-heading">
              {{ errorMessage }}
            </h4>

          </b-alert>

          <!-- BODY -->
          <validation-observer
            #default="{ handleSubmit }"
            ref="refFormObserver"
          >
            <!-- Form -->
            <b-form
              class=""
              @submit.prevent="handleSubmit(onSubmit)"
              @reset.prevent="resetForm"
            >
              <b-row>
                <b-col md="6">

                  <!-- Name -->
                  <validation-provider
                    #default="validationContext"
                    :name="$t('Tên thiết bị')"
                    rules="required"
                  >
                    <b-form-group>
                      <template #label>
                        <label class="d-block font-weight-bolder">Tên thiết bị <span class="text-danger">*</span></label>
                      </template>
                      <b-form-input
                        id="name"
                        v-model="itemData.name"
                        :state="getValidationState(validationContext)"
                        trim
                      />

                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <!-- Country -->
                  <validation-provider
                    #default="validationContext"
                    :name="$t('Nước sản xuất')"
                    rules="required|max:150"
                  >
                    <b-form-group label-for="country_id">
                      <template #label>
                        <label class="d-block font-weight-bolder">Nước sản xuất <span class="text-danger">*</span></label>
                      </template>
                      <v-select
                        v-model="itemData.country_id"
                        :options="dataCountry"
                        :reduce="val => val.id"
                        label="name_en"
                        placeholder="--Chọn--"
                      />
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <!-- Manufacture -->
                  <validation-provider
                    #default="validationContext"
                    :name="$t('Hãng sản xuất')"
                    rules="required"
                  >
                    <b-form-group label-for="manufacture_id">
                      <template #label>
                        <label class="d-block font-weight-bolder">Hãng sản xuất <span class="text-danger">*</span></label>
                      </template>
                      <v-select
                        v-model="itemData.manufacture_id"
                        :options="dataManufacture"
                        :reduce="val => val.id"
                        label="name"
                        placeholder="--Chọn--"
                        @input="changeManufacture($event)"
                      />
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                </b-col>
                <b-col md="6">
                  <!-- Phân loại thiết bị -->
                  <validation-provider
                    #default="validationContext"
                    :name="$t('Phân loại thiết bị')"
                    rules="required"
                  >
                    <b-form-group :state="getValidationState(validationContext)">
                      <template #label>
                        <label class="d-block font-weight-bolder">Phân loại thiết bị <span class="text-danger">*</span></label>
                      </template>
                      <v-select
                        v-model="itemData.category_type_device_id"
                        :options="dataCategoryTypeDevice"
                        :reduce="val => val.id"
                        label="name"
                        placeholder="--Chọn--"
                      />
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <!-- Nhà cung cấp -->
                  <validation-provider
                    #default="validationContext"
                    :name="$t('Nhà cung cấp')"
                    rules="required"
                  >
                    <b-form-group label-for="provider_id">
                      <template #label>
                        <label class="d-block font-weight-bolder">Nhà cung cấp <span class="text-danger">*</span></label>
                      </template>
                      <v-select
                        v-model="itemData.provider_id"
                        :options="dataProvider"
                        :reduce="val => val.id"
                        label="name"
                        placeholder="--Chọn--"
                      />
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <!-- Model -->
                  <validation-provider
                    #default="validationContext"
                    :name="$t('Model')"
                    rules="required"
                  >
                    <b-form-group label-for="provider_id">
                      <template #label>
                        <label class="d-block font-weight-bolder">Model <span class="text-danger">*</span></label>
                      </template>
                      <v-select
                        v-model="itemData.model_id"
                        :options="dataModel"
                        :reduce="val => val.id"
                        label="name"
                        placeholder="--Chọn--"
                      />
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                </b-col>
              </b-row>
              <hr class="mt-2">
              <b-row>
                <b-col md="6">
                  <validation-provider
                    #default="validationContext"
                    :name="$t('Ngày mua')"
                    rules="required"
                  >
                    <b-form-group>
                      <template #label>
                        <label class="d-block font-weight-bolder">Ngày mua <span class="text-danger">*</span></label>
                      </template>
                      <flat-pickr
                        v-model="itemData.buy_date"
                        class="form-control"
                        :config="config_date"
                        placeholder="dd-mm-yyyy"
                      />
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <!-- Ngày đưa vào sử dụng -->
                  <validation-provider
                    #default="validationContext"
                    :name="$t('Ngày đưa vào sử dụng')"
                    rules="required"
                  >
                    <b-form-group>
                      <template #label>
                        <label class="d-block font-weight-bolder">Ngày đưa vào sử dụng <span class="text-danger">*</span></label>
                      </template>
                      <flat-pickr
                        v-model="itemData.use_begin_date"
                        class="form-control"
                        :config="config_date"
                        placeholder="dd-mm-yyyy"
                      />
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <!-- Ngày nhập kho -->
                  <validation-provider
                    #default="validationContext"
                    :name="$t('Ngày nhập kho')"
                    rules="required"
                  >
                    <b-form-group>
                      <template #label>
                        <label class="d-block font-weight-bolder">Ngày nhập kho <span class="text-danger">*</span></label>
                      </template>
                      <flat-pickr
                        v-model="itemData.warehouse_import_date"
                        class="form-control"
                        :config="config_date"
                        placeholder="dd-mm-yyyy"
                      />
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <!-- Ngày nhập kho -->

                </b-col>
                <b-col md="6">
                  <!-- Thời gian bảo hành -->
                  <validation-provider
                    #default="validationContext"
                    :name="$t('Thời gian bảo hành')"
                    rules="required|positive"
                  >
                    <b-form-group>
                      <template #label>
                        <label class="d-block font-weight-bolder">Thời gian bảo hành (Đơn vị: Tháng) <span class="text-danger">*</span></label>
                      </template>
                      <b-form-input
                        id="name"
                        v-model="itemData.duration_warrantiry"
                        type="number"
                        min="1"
                        :state="getValidationState(validationContext)"
                        trim
                      />

                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <!-- Nguyên giá -->
                  <validation-provider
                    #default="validationContext"
                    :name="$t('Nguyên giá')"
                    rules="required"
                  >
                    <b-form-group>
                      <template #label>
                        <label
                          class="d-block font-weight-bolder"
                          title="Nguyên giá"
                        >Nguyên giá <span class="text-danger">(Nhập số lớn hơn 0)*</span></label>
                      </template>
                      <b-form-input
                        id="price_original"
                        v-model="itemData.price_original"
                        :state="getValidationState(validationContext)"
                        @keyup="convertCurrency()"
                      />

                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <!-- Tỷ lệ khấu hao -->
                  <validation-provider
                    #default="validationContext"
                    :name="$t('Tỷ lệ khấu hao/năm(%)')"
                    rules="required"
                  >
                    <b-form-group>
                      <template #label>
                        <label class="d-block font-weight-bolder">Tỷ lệ khấu hao/năm(%) <span class="text-danger">*</span></label>
                      </template>
                      <b-form-input
                        id="depreciation_rates"
                        v-model="itemData.depreciation_rates"
                        type="number"
                        min="1"
                        :state="getValidationState(validationContext)"
                        trim
                      />

                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>

              <hr class="mt-2">
              <b-row>
                <b-col md="6">
                  <validation-provider
                    #default="validationContext"
                    :name="$t('Nơi quản lý')"
                    rules="required"
                  >
                    <b-form-group label-for="department_id">
                      <template #label>
                        <label class="d-block font-weight-bolder">Nơi quản lý <span class="text-danger">*</span></label>
                      </template>
                      <v-select
                        v-model="itemData.department_id"
                        :options="dataDepartment"
                        :reduce="val => val.id"
                        label="name"
                        placeholder="--Chọn--"
                        @input="changeDepartment($event)"
                      />
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="6">
                  <validation-provider
                    #default="validationContext"
                    :name="$t('Người quản lý')"
                    rules="required"
                  >
                    <b-form-group label-for="manager_id">
                      <template #label>
                        <label class="d-block font-weight-bolder">Người quản lý <span class="text-danger">*</span></label>
                      </template>
                      <v-select
                        v-model="itemData.manager_id"
                        :options="dataUser"
                        :multiple="true"
                        :reduce="val => val.id"
                        label="full_name"
                        placeholder="--Chọn--"
                      />
                      <b-form-invalid-feedback :state="getValidationState(validationContext)">
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
              <hr class="mt-2">
              <!-- <validation-provider
                #default="validationContext"
                :name="$t('Series')"
                rules="required"
              >
                <b-form-group
                  label-for="Series"
                >
                  <template #label>
                    <label class="d-block font-weight-bolder">Series <span
                      class="text-danger"
                    >*</span></label>
                  </template>
                  <div
                    v-for="item in seriesName"
                    :key="item.name"
                  >

                    <b-form-tags
                      v-model="item.name "
                      input-id="tags-separators"
                      placeholder="Nhập các series được phân tách và bấm enter"
                    />
                  </div>
                  <b-form-invalid-feedback :state="getValidationState(validationContext)">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider> -->
              <template>
                <div>
                  <b-form-tags
                    v-model="seriesName"
                    no-outer-focus
                    class="mb-2"
                  >
                    <template v-slot="{ tags, inputAttrs, inputHandlers, tagVariant, addTag, removeTag }">
                      <b-input-group class="mb-2">
                        <b-form-input
                          v-bind="inputAttrs"
                          placeholder="Thêm series - Ấn Enter để thêm"
                          class="form-control"
                          v-on="inputHandlers"
                        />
                        <b-input-group-append>
                          <b-button
                            variant="primary"
                            @click="addTag()"
                          >
                            Thêm
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <div
                        class="d-inline-block"
                        style="font-size: 1.5rem;"
                      >
                        <b-form-tag
                          v-for="tag in seriesName"
                          :key="tag.id"
                          :title="tag.name"
                          :variant="tagVariant"
                          class="mr-1"
                          @remove="removeTag(tag)"
                        >{{ tag }}
                        </b-form-tag>
                        <!-- <b-form-tag
                          v-for="tag in seriesName"
                          :key="tag.id"
                          :title="tag.name"
                          :variant="tagVariant"
                          class="mr-1"
                          @remove="removeTag(tag)"
                        >{{ JSON.parse(tag).name }}
                        </b-form-tag> -->
                      </div>
                    </template>
                  </b-form-tags>
                </div>
              </template>
              <b-form-group>
                <template #label>
                  <label class="d-block font-weight-bolder">Ghi chú </label>
                </template>
                <b-form-input
                  id="note"
                  v-model="itemData.note"
                />
              </b-form-group>

              <!-- Form Actions -->
              <div class="d-flex mt-2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mr-2"
                  type="submit"
                >
                  {{ $t('Save') }}
                </b-button>
              </div>

            </b-form>
          </validation-observer>
        </b-card>

      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BRow, BCol, BCard, BAlert, BOverlay, BForm, BFormGroup, BButton, BFormInput, BFormInvalidFeedback,
  BFormTags, BTooltip, BInputGroupAppend, BFormTag, BInputGroup,
} from 'bootstrap-vue'
import {
  ref, watch,
} from '@vue/composition-api'
import store from '@/store'
import { useRouter, showToast } from '@core/utils/utils';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, alphaNum, alphaNumDot, max, integer, positive,
} from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'

import flatPickr from 'vue-flatpickr-component'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import vSelect from 'vue-select'

function formatPrice(val) {
  const price = val.toString().replace(/,/g, '');
  return price;
}
export default {
  components: {
    AppBreadcrumb,
    BRow,
    BCol,
    BCard,
    BAlert,
    BOverlay,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    BFormTags,
    BTooltip,
    BInputGroupAppend,
    BInputGroup,
    BFormTag,
    vSelect,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      integer,
      alphaNum,
      alphaNumDot,
      max,
      positive,

    }
  },
  methods: {
    changeManufacture(event) {
      this.itemData.model_id = ''
      store.dispatch('manufacturer/show', { id: event })
        .then(response => {
          if (response.data.code === 200) {
            this.dataModel = response.data.data.models;
          }
        })
    },
    changeDepartment(event) {
      this.itemData.manager_id = []
      store.dispatch('departments/fetchDepartment', { id: event })
        .then(response => {
          if (response.data.code === 200) {
            this.dataUser = response.data.data.users;
          }
        })
    },
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const id = ref(route.value.params.id !== undefined ? route.value.params.id : 0);
    const layout = ref(route.value.name !== 'devices-edit' ? 'add' : 'edit');
    const loading = ref(!!id.value)
    const errorMessage = ref('')
    const devices = ref([])
    const dataCountry = ref([])
    const dataManufacture = ref([])
    const dataCategoryTypeDevice = ref([])
    const dataProvider = ref([])
    const dataModel = ref([])
    const dataDepartment = ref([])
    const dataUser = ref([])
    const seriesName = ref([])
    const defaultItemData = {
      name: '',
      category_type_device_id: null,
      country_id: null,
      manufacture_id: null,
      provider_id: null,
      model_id: null,
      buy_date: '',
      use_begin_date: '',
      warehouse_import_date: '',
      duration_warrantiry: '',
      price_original: '',
      depreciation_rates: '',
      department_id: null,
      manager_id: [],
      series: [],
      note: '',
    }
    const itemData = ref(JSON.parse(JSON.stringify(defaultItemData)))

    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetItemData)

    const onSubmit = () => {
      errorMessage.value = '';
      loading.value = true;

      const { price_original } = itemData.value;
      itemData.value.price_original = formatPrice(price_original)
      itemData.value.series = seriesName
      if (layout.value === 'edit') {
        store.dispatch('device/update', { id: id.value, data: itemData.value })
          .then((response) => {
            loading.value = false
            if (response.status === 200) {
              if (response.data.code === 200) {
                showToast(response.data.message, { variant: 'success' });
                router.push({ name: 'devices-list' })
              } else {
                showToast(response.data.message)
                errorMessage.value = response.data.message;
              }
            }
          })
      } else {
        store.dispatch('device/create', itemData.value)
          .then((response) => {
            loading.value = false
            if (response.status === 200) {
              if (response.data.code === 200) {
                showToast(response.data.message, { variant: 'success' });
                router.push({ name: 'devices-list' })
              } else {
                showToast(response.data.message)
                errorMessage.value = response.data.message;
              }
            }
          })
      }
    }
    const convertCurrency = () => {
      let val = itemData.value.price_original.toString()
      val = val.replace(/,/g, '');

      // eslint-disable-next-line eqeqeq
      if (+val != 0 && !+val) {
        itemData.value.price_original = ''
      } else {
        let subString = val.substring(0, 1);
        if (subString === 0 || subString === '0') {
          subString = val.substring(1);
        } else {
          subString = val;
        }
        const hT = subString.split('.');
        const head = hT[0].split('');
        if (head.length > 3) {
          let index = 3;
          while (head.length - index >= 1) {
            head.splice(head.length - index, 0, ',');
            index += 4;
          }
        }
        itemData.value.price_original = hT.length > 1 ? `${head.join('')}.${hT[1]}` : head.join('');
      }
    }
    const fetchDepartment = () => {
      store.dispatch('departments/fetchDepartments', {
        type: 'all',
      })
        .then(response => {
          if (response.data.code === 200) {
            dataDepartment.value = response.data.data;
          }
        })
    }
    fetchDepartment();

    // fetchModel
    // const fetchModel = () => {
    //   store.dispatch('model/fetchAll', {
    //     isPaginate: '0',
    //   })
    //     .then(response => {
    //       if (response.data.code === 200) {
    //         dataModel.value = response.data.data;
    //       }
    //     })
    // }
    // fetchModel();

    const fetchCountry = () => {
      store.dispatch('country/fetchAll', {
        isPaginate: '0',
      })
        .then(response => {
          if (response.data.code === 200) {
            dataCountry.value = response.data.data;
          }
        })
    }
    fetchCountry();

    const fetchManufacture = () => {
      store.dispatch('manufacturer/fetchAll', {
        isPaginate: '0',
        type: 10,
      })
        .then(response => {
          if (response.data.code === 200) {
            dataManufacture.value = response.data.data;
          }
        })
    }
    fetchManufacture();

    const fetchProvider = () => {
      store.dispatch('provider/fetchAll', {
        isPaginate: '0',
      })
        .then(response => {
          if (response.data.code === 200) {
            dataProvider.value = response.data.data;
          }
        })
    }
    fetchProvider();

    const fetchCategoryTypeDevice = () => {
      store.dispatch('device/fetchAllCategoryTypeDevice', {
        isPaginate: '0',
      })
        .then(response => {
          if (response.data.code === 200) {
            dataCategoryTypeDevice.value = response.data.data;
          }
        })
    }
    fetchCategoryTypeDevice();

    // const fetchManager = () => {
    //   store.dispatch('users/fetchUsers', {
    //     isPaginate: '0',
    //   })
    //     .then(response => {
    //       if (response.data.code === 200) {
    //         dataUser.value = response.data.data;
    //       }
    //     })
    // }
    // fetchManager();

    const fetchData = () => {
      loading.value = true;
      store.dispatch('device/fetchOne', { id: id.value })
        .then(response => {
          if (response.status === 200) {
            itemData.value = response.data.data
            convertCurrency();
            seriesName.value = itemData.value.series.map(o => o.name);
            // seriesName.value = itemData.value.series.map(o => ({
            //   name: o.name,
            //   id: o.id,
            // }));

            loading.value = false
            errorMessage.value = '';
          } else {
            errorMessage.value = response.message
            loading.value = false
          }
        })
    }
    if (id.value && layout.value === 'edit') {
      fetchData();
    }

    watch(
      () => context.root.$route,
      (to) => {
        if (to.name === 'devices-add') {
          resetItemData();
        } else {
          fetchData();
        }
      },
    )
    const config_date = ref({
      dateFormat: 'd-m-Y',
      wrap: true,
      locale: Vietnamese, // locale for this instance only
    });

    return {
      id,
      layout,
      errorMessage,
      loading,
      itemData,
      devices,
      refFormObserver,
      getValidationState,
      resetForm,
      resetItemData,
      onSubmit,
      fetchData,
      dataCountry,
      dataManufacture,
      dataCategoryTypeDevice,
      dataProvider,
      dataModel,
      dataDepartment,
      dataUser,
      config_date,
      convertCurrency,
      seriesName,
    }
  },

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
